import React from 'react'

const FeatureFlagStatusContext = React.createContext({ isLoading: false })

export default FeatureFlagStatusContext
